



























































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

import Footer from './Footer';

@Component({
  name: 'maucash-model',
  components: {
    Footer,
  },
})
export default class MaucashModel extends Vue {
  // 显示与隐藏，绑定到v-model上的值
  @Prop({ type: Boolean, default: false, required: true }) private value!: boolean;

  // 标题
  @Prop({ type: String, default: '', required: false }) private title!: string;

  // 是否隐藏头部
  @Prop({ type: Boolean, default: false, required: false }) private isHideHeader!: boolean;

  // 是否隐藏底部
  @Prop({ type: Boolean, default: false, required: false }) private isHideFooter!: boolean;

  // 关闭的事件回调
  @Prop({ type: Function, required: false }) private closeFunc!: () => void;

  // 关闭按钮文字
  @Prop({ type: String, default: '关闭', required: false }) private closeText!: string;

  // 确认的事件回调
  @Prop({ type: Function, required: false }) private confirmFunc!: () => void;

  // 确认按钮文字
  @Prop({ type: String, default: '确认', required: false }) private confirmText!: string;

  // 底部自定义render函数
  @Prop({ type: Function, required: false }) private render!: () => void;

  // 弹框的宽度
  @Prop({ type: Number, default: 450, required: false }) private width!: number;

  // 弹框的高度
  @Prop({ type: Number, default: 300, required: false }) private height!: number;

  // 内容体的样式
  @Prop({ type: Object, default: () => ({}), required: false }) private bodyStyle!: { [propsName: string]: any };

  // 是否可拖动
  @Prop({ type: Boolean, default: false, required: false }) private draggable!: boolean;

  // 是否隐藏取消按钮
  @Prop({ type: Boolean, default: false, required: false }) private isHideCloseBtn!: boolean;

  // 是否隐藏确认按钮
  @Prop({ type: Boolean, default: false, required: false }) private isHideConfimBtn!: boolean;

  // 计算属性
  private get contentStyle() {
    return {
      width: this.width + 'px',
      height: this.height + 'px',
    };
  }

  // 关闭事件
  @Emit('input')
  private close(): boolean {
    return false;
  }

  // 关闭按钮事件
  private closeBtn() {
    if (this.closeFunc) {
      this.closeFunc();
    } else {
      this.close();
    }
  }

  // 确认按钮事件
  private confirmBtn() {
    if (this.confirmFunc) {
      this.confirmFunc();
    } else {
      this.close();
    }
  }

  // 拖拽事件
  private move(e: any) {
    const odiv: HTMLElement = e.target.parentNode.parentNode;
    if (this.draggable) {
      // 算出鼠标相对元素的位置
      const disX: number = e.clientX - odiv.offsetLeft;
      const disY: number = e.clientY - odiv.offsetTop;
      document.onmousemove = (event: any) => {
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left: number = event.clientX - disX;
        let top: number = event.clientY - disY;
        // 计算能移动的最大位置与最小位置
        const maxX: number = document.documentElement.clientWidth - odiv.offsetWidth;
        const maxY: number = document.documentElement.clientHeight - odiv.offsetHeight;
        // if (left < 0) {
        //   left = 0;
        // } else if (left > maxX) {
        //   left = maxX;
        // }
        // if (top < 0) {
        //   top = 0;
        // } else if (top > maxY) {
        //   top = maxY;
        // }
        left = Math.min(maxX, Math.max(0, left));
        top = Math.min(maxY, Math.max(0, top));
        // 移动当前元素
        odiv.style.left = left + 'px';
        odiv.style.top = top + 'px';
        odiv.style.margin = 'unset';
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
}
